const COOKIES_CHOICES_KEY = 'cookiesChoices';

export { COOKIES_CHOICES_KEY };
